import React from 'react';
import styles from './Footer.module.scss';
import { StyleService, TranslationService } from '../../services';
import { useAppContext } from '../../../AppContext';
import FooterApi from '../../api/FooterApi';
import { useQuery } from 'react-query';
import { useAuthenticationContext } from '../../services/AuthenticationProvider';
import styled, { css } from 'styled-components';
import { ActionStatusType } from '../../types/ActionStatusType';
import classNames from 'classnames';
import { DictionaryType } from '../../types/DictionaryType';
import GlobalConfig from '../../api/GlobalConfig';

type FooterSettingsType = {
  email: string;
  emailText: string;
  isFooterEnabled: boolean;
  telNumber: string;
  telNumberFormatted: string;
};

const Footer = () => {
  const context = useAppContext();
  const authContext = useAuthenticationContext();
  const whitelabelingStyles = StyleService.applyMany(
    ['module:footer', 'module:footer:logo'],
    context.styles
  );

  const footerSettingsRes = useQuery<ActionStatusType<FooterSettingsType>>(
    'footer',
    FooterApi.fetchFooterSettings,
    {
      enabled:
        !!context.translations &&
        !!context.defaultLanguage &&
        !!authContext.isAuthenticated,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return (
    <FooterDiv className={styles.footerWrapper} styles={whitelabelingStyles}>
        {footerSettingsRes.isFetched &&
        footerSettingsRes.data?.data.isFooterEnabled && (
          <div className="container">
            <div className={styles.footerContent}>
              <div className={styles.footerGroup}>
                <div className={styles.footerContact}>
                  <div className={styles.footerEmail}>
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${footerSettingsRes.data.data?.email}`}>
                      {footerSettingsRes.data.data?.email
                        ? footerSettingsRes.data.data?.email
                        : TranslationService.translate('Email')}
                    </a>
                  </div>
                  <div className={styles.footerPhone}>
                    <i className="fas fa-mobile-alt"></i>
                    <a
                      href={`tel:${footerSettingsRes.data.data?.telNumberFormatted}`}
                    >
                      {footerSettingsRes.data.data?.telNumberFormatted
                        ? footerSettingsRes.data.data?.telNumberFormatted
                        : TranslationService.translate('TelephoneNr')}
                    </a>
                  </div>
                </div>
                <div className={styles.footerInfo}>
                  <div className={styles.footerVersion}>
                      <i className="fas fa-info-circle"></i>
                      <div>
                          {`v${GlobalConfig.val().Version}`}
                      </div>
                  </div>

                  <div className={styles.logoWrapper}>
                    <img
                      src={whitelabelingStyles['module:footer:logo'].backgroundImage || `images/logo-banqsoft-gray.png`}
                      className={styles.logo}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </FooterDiv>
  );
};

const FooterDiv = styled.span<{ styles: DictionaryType<DictionaryType<string>> }>`
  ${(props) =>
    css`
      --footer-background-color: ${props.styles['module:footer'].backgroundColor};
      --footer-text-color: ${props.styles['module:footer'].textColor};
    `}
`;

export default Footer;
